import { Link, useParams } from "react-router-dom";
import "./Register.css";
import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Slide, Stack } from "@mui/material";
import { validarEmail, validarRegistro, validarRut} from "global/util/validators";
import { createTheme } from "@mui/material/styles";
import { blue, orange } from '@mui/material/colors';
import { TransitionProps } from '@mui/material/transitions';
import { ElectricalServicesTwoTone } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress'; 
import { isHttpError, postJson } from "api/httpClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});


export const Register = () => {

	const [firstTry, setFirstTry] = useState(false);
	const [firstTryRut, setFirstTryRut] = useState(false);
	const [firstTryName, setFirstTryName] = useState(false);
	const [email, setEmail] = useState('');

	const [name, setName] = useState('');
	const [showErrors, setShowErrors] = useState<any>({ state: true, errors: [] })

	const [loading, setLoading] = useState(false)
	const [open, setOpen] = useState(false);
	const [noApareces, setNoApareces] = useState(false);
	const [polityCheck, setPolityCheck] = useState(false);
	const [conditionsCheck, setConditionsCheck] = useState(false);
	const [polityCheckDisabled, setPolityCheckDisabled] = useState(true);
	const [conditionsCheckDisabled, setConditionsCheckDisabled] = useState(true);

	const handleCloseModal = () => {
		setOpen(false);
	};
	const openNoApareces = () => {
		setNoApareces(true);
	};
	const handleCloseModalNoAparece = () => {
		setNoApareces(false);
	};

	const handlePolityCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPolityCheck(event.target.checked);
	}
	const handleConditionsCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
		setConditionsCheck(event.target.checked);
	}

    const validarName = (name: any)=>{
        if(name && name.trim()===''){
            return false;
        }else if(name){
            return true;
        }
        return false;
    }
	const handleNameChange = (name: string) => {
		let nameTmp = name;
		setName(nameTmp);
	};


	const getBodyRequest = (email: string, nombres: string) => {
		return {
			"email": email,
			"name": nombres
		}
	}


	const handleRegistration = async () => {
		if(loading){
			return;
		}
		let resp;
		if(!polityCheck || !conditionsCheck ){
			setShowErrors({
					state: false,
					errors: [{ code: 1, message: 'Debe aceptar políticas de privacidad, y términos y condiciones' }]
				})
			return;
		}else{
			setShowErrors({
					state: true,
					errors: []
				})
		}
		try {
			setLoading(true)
			setShowErrors(validarRegistro({ email, nombres: name, userType:"", rut:"" }))
			if(!showErrors.state){
				return;
			}
			const body = getBodyRequest(email, name)
			resp = await postJson<any>(`${API_BASE_URL}/create-user`, body)
			console.log(JSON.stringify(showErrors));
			console.log(JSON.stringify(resp));
			if (resp.code === 'USER_CREATED') {
				setOpen(true);
			} else {
				setShowErrors({
					state: false,
					errors: [{ code: 1, message: JSON.stringify(resp.message) }]
				})
			}
		} catch (error) {
			console.error("Ha ocurrido un error: ", JSON.stringify(error))
			if (isHttpError(error) && error.code === "ERR_BAD_REQUEST") {
				const data = error.response.data as { errorMessage?: string; message?: string } | null;
				setShowErrors({
					state: false,
					errors: [{ code: 1, message: JSON.stringify(data?.errorMessage ?? data?.message) }]
				})
			}else{
				alert("Error al crear usuario. Por favor contactarse a calculadora@hubtec.cl");
			}
		}finally{
			setLoading(false);
		}

	};
	return (
		<div style={{  width: "80%", margin: "0px auto", maxWidth: "900px", display: "grid", gridTemplateColumns: "1fr", gap: "10px", }}>
			
			<Box
				className="home-component"
				sx={{ width: 400, marginTop: 3, marginBottom: 5, backgroundColor: "white" }}
			>
				<div className="registration-container">
					<h2>Registro de usuario</h2>					
                    <TextField error={firstTryName && !validarName(name)} onBlur={() => setFirstTryName(true)} fullWidth sx={{ mt: 1, mb: 1 }} id="outlined-basic" type="text" value={name} label="Nombre completo"  onChange={(e) => handleNameChange(e.target.value)} />
					<TextField error={firstTry && !validarEmail(email)} onBlur={() => setFirstTry(true)} fullWidth sx={{ mt: 1, mb: 1 }} id="outlined-basic" label="Correo electrónico" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
					

					<Checkbox
						className="contact-form-checkbox-form-input"
						checked={polityCheck}
						onChange={handlePolityCheck}
					/>
					
					<span className="contacto-form-policies">
						He leído y acepto las <Link to={{ pathname: `/politicas` }} target='_blank'>políticas de privacidad </Link>
					</span><br></br>
					
					<Checkbox
						className="contact-form-checkbox-form-input"
						checked={conditionsCheck}
						onChange={handleConditionsCheck}
					/>
					
					<span className="contacto-form-policies">
						He leído y acepto los <Link to={{ pathname: `/condiciones` }} target='_blank'>términos y condiciones </Link>
					</span>
					{
						!showErrors.state ?
							<>
								{showErrors.errors.map((error: any) => {
									return <p style={{ color: "red" }}>*{error.message}</p>
								})}
							</> :
							<></>
					}
					<Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
						<Button variant="contained" onClick={handleRegistration} className="app-primary-button" >
							
							{loading ? <CircularProgress size={24} color="inherit" /> : "Registrarse"}
						</Button>
					</Stack>
				</div>

				<Dialog
					open={open && showErrors.state}
					TransitionComponent={Transition}
					keepMounted
					onClose={handleCloseModal}
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle>{"Confirmación de email"}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							Revisa tu correo electr&oacute;nico, hemos enviado un enlace de confirmaci&oacute;n para terminar el registro.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Link to={`/`} onClick={handleCloseModal}>
							<Button>Ir a la pagina principal</Button>
						</Link>
						<Link to={`/login`} onClick={handleCloseModal}>
							<Button>Ingresar a la plataforma</Button>
						</Link>
					</DialogActions>

				</Dialog>

				<Dialog
					open={noApareces}
					TransitionComponent={Transition}
					keepMounted
					onClose={handleCloseModalNoAparece}
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle>{"Solicitud de registro"}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							Lo sentimos! Actualmente no te encuentras en nuestros registros. Favor inscríbete en el siguiente <a href="https://forms.gle/WwUui48dfDrprypZ7" target="_blank" rel="noopener noreferrer">
								formulario
							</a>.
						</DialogContentText>

						<DialogContentText id="alert-dialog-slide-description">
							Te comunicaremos una vez que el perfil haya sido ingresado a CaPS.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Link to={`/`} onClick={handleCloseModalNoAparece}>
							<Button>Aceptar</Button>
						</Link>
					</DialogActions>
				</Dialog>
			</Box>

		</div>
	);
};
